export default "/fonts/AvenirNextLTPro-DemiIt.ttf";